import React from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

import { useNavigation } from '../../../common/navigation';
import { useTranslation } from '../../../common/hooks/useTranslation';

interface NewWindowButtonProps {
  projectId: string;
}

export const NewWindowButton: React.FC<NewWindowButtonProps> = props => {
  const { t, tk } = useTranslation('projectLng');
  const nav = useNavigation();

  const handleClick = () => {
    return nav.projectDetails(props.projectId, true, 'estimates');
  };

  return (
    <OverlayTrigger overlay={<Tooltip>{t(tk.common.openNewCard)}</Tooltip>}>
      <Button
        onClick={e => {
          e.stopPropagation();
          handleClick();
        }}
        variant="btn-info"
        className="px-2"
      >
        <Icon.BoxArrowUpRight className="icon-blue" size={16} />
      </Button>
    </OverlayTrigger>
  );
};
